<template>
  <b-dropdown-item
    @click="updateSource"
  >
    {{ $t('TABLES.PROJECT_USER_NAVS.CHANGE_SOURCE') }}
  </b-dropdown-item>
</template>

<script>
import { mapGetters } from "vuex";
import { BULK_UPDATE_PROJECT_USER_SAMPLE } from "@/modules/together-helpers/vuex/project/project_user_sample.module";

export default {
  name: "UpdateSource",

  props: {
    checkedUsers: { type: Array, required: true }
  },

  methods: {
    updateSource: function() {
      this.$swal.fire({
        title: `${this.$t("SWEETALERTS.CHANGE_SOURCE.TITLE")}`,
        text: `${this.$t("SWEETALERTS.CHANGE_SOURCE.MESSAGE")}`,
        input: 'select',
        inputOptions: this.computedOptions,
        inputPlaceholder: `${this.$t("GENERAL.PROJECT_USER_FILTER.SOURCE_LABEL")}`,
        showCancelButton: true,
        confirmButtonText: `${this.$t("GENERAL.TEXT.CONFIRM")}`,
        inputValidator: (value) => {
          let payload = {
            projectId: this.projectInfo.id,
            data: {
              users: this.checkedUsers,
              system_project_user_sample_id: value
            }
          };
          this.$store
            .dispatch(BULK_UPDATE_PROJECT_USER_SAMPLE, payload)
            .then(() => {
              this.alertSuccess();
              this.$emit('users_changed');
            })
            .catch(() => {
              this.alertFailure();
            });
        }
      })
    },
    alertSuccess: function() {
      this.$swal.fire({
        title: `${this.$t("SWEETALERTS.CHANGE_SOURCE_BULK_SUCCESS.TITLE")}`,
        text: `${this.$t("SWEETALERTS.CHANGE_SOURCE_BULK_SUCCESS.MESSAGE")}`,
        icon: 'success',
        confirmButtonText: `${this.$t("GENERAL.TEXT.CONFIRM")}`
      })
    },
    alertFailure: function() {
      this.$swal.fire({
        title: `${this.$t("SWEETALERTS.CHANGE_SOURCE_BULK_FAIL.TITLE")}`,
        text: `${this.$t("SWEETALERTS.CHANGE_SOURCE_BULK_FAIL.MESSAGE")}`,
        icon: 'error',
        confirmButtonText: `${this.$t("GENERAL.TEXT.CONFIRM")}`
      })
    }
  },

  computed: {
    ...mapGetters([
      "projectInfo",
      "systemProjectUserSamples"
    ]),
    computedOptions: function() {
      let samples = {};

      this.systemProjectUserSamples.forEach(function(sample) {
        samples[sample.value] = sample.label;
      })

      return samples;
    }
  }
};
</script>
